export interface Comment {
  id: string;
  author: string;
  authorBadge?: "마스터" | "정수강생";
  content: string;
  createdAt: string;
  isAI?: boolean;
}

export interface Post {
  id: string;
  title: string;
  content: string;
  category: "공지/이벤트" | "자유수다" | "물건 Q&A" | "낙찰/임장 후기";
  author: string;
  authorBadge?: "마스터" | "정수강생";
  createdAt: string;
  views: number;
  likes: number;
  commentCount: number;
  comments: Comment[];
  thumbnail?: string;
  isBest?: boolean;
  pinned?: boolean;
  resolved?: boolean;
  tags?: string[];
}

export const communityTabs = [
  { key: "all", label: "전체", icon: "ri-global-line" },
  { key: "notice", label: "공지/이벤트", icon: "ri-megaphone-line" },
  { key: "free", label: "자유수다", icon: "ri-chat-smile-2-line" },
  { key: "qna", label: "물건 Q&A", icon: "ri-question-answer-line" },
  { key: "review", label: "낙찰/임장 후기", icon: "ri-camera-line" },
];

export const posts: Post[] = [
  // ── 공지/이벤트 ──
  {
    id: "n1",
    title: "2026년 6월 오프라인 특강 일정 안내",
    content: "6월 오프라인 특강은 '경매현장답사'와 '권리분석 실습' 두 가지로 진행됩니다. 경매현장답사는 6월 14일(토) 오전 10시 수원지방법원에서 진행되며, 권리분석 실습은 6월 21일(토) 오후 2시 강남 강의실에서 진행됩니다. 각 특강은 선착순 20명까지 신청 가능합니다.\n\n참가 신청은 강스터디 홈페이지 > 강의 메뉴에서 하실 수 있으며, 기존 수강생분들은 20% 할인이 적용됩니다.",
    category: "공지/이벤트",
    author: "관리자",
    createdAt: "2026-05-25",
    views: 1240,
    likes: 48,
    commentCount: 5,
    comments: [
      { id: "n1c1", author: "김민수", authorBadge: "정수강생", content: "현장답사 꼭 참여하고 싶습니다! 신청 완료했어요.", createdAt: "2026-05-25" },
      { id: "n1c2", author: "이지은", authorBadge: "정수강생", content: "권리분석 실습도 신청했습니다. 기대돼요!", createdAt: "2026-05-26" },
      { id: "n1c3", author: "관리자", content: "많은 관심 감사합니다. 현장답사는 마감 임박이니 서둘러 주세요!", createdAt: "2026-05-26" },
    ],
    pinned: true,
  },
  {
    id: "n2",
    title: "강스터디 홈페이지 리뉴얼 오픈 안내",
    content: "강스터디가 새로운 홈페이지로 리뉴얼 오픈했습니다. 더욱 편리해진 경매 물건 검색, 체계적인 교육과정, 전문가 상담 서비스를 만나보세요.\n\n주요 변경사항:\n1. AI 경매비서 도입 - 물건 분석을 더 빠르게\n2. 입찰계산기 신규 오픈 - 최적 입찰가 자동 계산\n3. 커뮤니티 강화 - 자유수다, 물건 Q&A, 낙찰 후기 게시판 신설\n\n기존 회원분들의 수강 내역과 결제 정보는 그대로 유지됩니다.",
    category: "공지/이벤트",
    author: "관리자",
    createdAt: "2026-05-20",
    views: 3210,
    likes: 72,
    commentCount: 8,
    comments: [
      { id: "n2c1", author: "박성호", authorBadge: "마스터", content: "새로운 사이트 정말 깔끔하네요! 입찰계산기 진짜 유용합니다.", createdAt: "2026-05-20" },
      { id: "n2c2", author: "최유진", authorBadge: "정수강생", content: "AI 비서 기능 기대됩니다. 얼른 써보고 싶어요.", createdAt: "2026-05-20" },
    ],
    pinned: true,
  },
  {
    id: "n3",
    title: "입찰가 산정 실전반 가격 인상 사전 안내",
    content: "2026년 7월 1일부터 입찰가 산정 실전반의 수강료가 450,000원에서 500,000원으로 인상될 예정입니다. 6월 30일까지 기존 가격으로 수강 신청이 가능하니 서둘러 신청해주세요. 입찰가 산정 실전반은 실제 경매 데이터를 기반으로 최적의 입찰가를 산정하는 방법을 실습하는 프리미엄 과정입니다.",
    category: "공지/이벤트",
    author: "관리자",
    createdAt: "2026-05-18",
    views: 890,
    likes: 15,
    commentCount: 3,
    comments: [],
    pinned: false,
  },
  {
    id: "n4",
    title: "[이벤트] 2분기 경매시장 분석 리포트 무료 배포",
    content: "강스터디 연구소에서 2026년 2분기 서울 및 경기권 경매 시장 분석 리포트를 무료로 배포합니다. 지역별 낙찰가율, 평균 응찰자 수, 유찰 추이 등 상세 데이터를 확인하실 수 있습니다.\n\n이벤트 기간: 6월 1일 ~ 6월 30일\n참여 방법: 리포트 메뉴에서 '무료' 탭 클릭 후 다운로드\n혜택: 선착순 500분께 추가 분석자료 PDF 제공",
    category: "공지/이벤트",
    author: "강스터디 연구소",
    createdAt: "2026-05-15",
    views: 1560,
    likes: 89,
    commentCount: 12,
    comments: [],
    pinned: false,
  },

  // ── 자유수다 ──
  {
    id: "f1",
    title: "오늘 첫 법원 경매 현장 다녀왔습니다!",
    content: "드디어 첫 경매 법원에 다녀왔어요. 생각보다 사람이 많아서 깜짝 놀랐습니다. 수원지방법원이었는데 경매 법정이 꽉 차더라고요. 입찰표 작성하는 것도 처음이라 긴장했는데, 옆에 계신 분이 친절하게 알려주셔서 무사히 제출했습니다. 결과는 다음 주인데 벌써 떨리네요. 혹시 첫 입찰 때 꿀팁 있으신 분들 공유 부탁드려요!",
    category: "자유수다",
    author: "경매뉴비",
    authorBadge: "정수강생",
    createdAt: "2026-06-07",
    views: 340,
    likes: 28,
    commentCount: 9,
    comments: [
      { id: "f1c1", author: "낙찰왕", authorBadge: "마스터", content: "축하드려요! 첫 입찰은 누구나 떨리죠. 입찰액은 미리 입찰계산기로 계산해가시는 게 좋아요.", createdAt: "2026-06-07" },
      { id: "f1c2", author: "초보탈출", content: "저도 다음 주에 첫 입찰인데 정보 감사합니다. 혹시 입찰보증금은 어떻게 준비하셨어요?", createdAt: "2026-06-07" },
      { id: "f1c3", author: "경매뉴비", authorBadge: "정수강생", content: "입찰보증금은 입찰금액의 10%를 수표로 준비했어요. 법원 1층 은행에서 발급받았습니다.", createdAt: "2026-06-08" },
    ],
  },
  {
    id: "f2",
    title: "경매 공부 시작한 지 3개월, 드디어 감이 잡히네요",
    content: "처음에는 등기부등본 보는 것도 막막했는데 강현우 강사님 강의 3회독 하고 나니까 이제 혼자서도 어느 정도 권리분석이 되네요. 가장 도움된 건 실전반에서 실제 물건 가지고 분석해보는 실습이었어요. 아직 낙찰은 못 받았지만, 이제는 어떤 물건이 좋은 물건인지 구분할 수 있게 됐습니다. 다들 처음에 어떻게 공부하셨나요?",
    category: "자유수다",
    author: "공부하는직장인",
    authorBadge: "정수강생",
    createdAt: "2026-06-05",
    views: 215,
    likes: 35,
    commentCount: 7,
    comments: [],
  },
  {
    id: "f3",
    title: "요즘 경매시장 분위기 어떤가요?",
    content: "최근 금리 인하 가능성 때문에 경매시장이 좀 달아오르는 느낌인데, 다들 어떻게 보시나요? 저는 오히려 지금이 기회라고 생각하는데, 주변에서는 조금 더 기다리라고 하네요. 고수분들 의견 궁금합니다.",
    category: "자유수다",
    author: "시장분석가",
    createdAt: "2026-06-03",
    views: 520,
    likes: 42,
    commentCount: 15,
    comments: [
      { id: "f3c1", author: "강현우", authorBadge: "마스터", content: "금리 인하 가능성이 높아지면 경매시장은 오히려 과열될 가능성이 있어요. 지금이 적기라고 봅니다.", createdAt: "2026-06-03" },
    ],
  },
  {
    id: "f4",
    title: "강스터디 수강생들끼리 스터디 모임 만들어요!",
    content: "서울/경기 지역 수강생분들끼리 주말에 오프라인 스터디 모임 어떨까요? 서로 물건 분석도 공유하고, 법원 답사도 함께 가고, 정보도 나누면 좋을 것 같아서요. 관심 있으신 분들 댓글 남겨주세요. 장소는 강남역 근처 카페 생각하고 있습니다.",
    category: "자유수다",
    author: "스터디장",
    authorBadge: "마스터",
    createdAt: "2026-06-01",
    views: 890,
    likes: 67,
    commentCount: 22,
    comments: [],
  },

  // ── 물건 Q&A ──
  {
    id: "q1",
    title: "선순위 임차인 있는 물건, 낙찰받아도 괜찮을까요?",
    content: "관심 있는 물건이 있는데 등기부등본 확인해보니 선순위 임차인이 있어요. 보증금이 5천만원인데, 이 경우 낙찰 받으면 제가 인수해야 하는 건가요? 아니면 배당에서 해결되나요? 매각대금에서 배당되는 기준이 궁금합니다.",
    category: "물건 Q&A",
    author: "첫입찰준비",
    authorBadge: "정수강생",
    createdAt: "2026-06-06",
    views: 280,
    likes: 12,
    commentCount: 4,
    comments: [
      { id: "q1c1", author: "AI 경매비서", content: "안녕하세요! AI 경매비서입니다. 등기부등본 기준으로 선순위 임차인의 보증금 5천만원은 말소기준권리보다 앞서는 경우 인수될 수 있습니다. 구체적으로는:\n\n1. 대항력 있는 임차인이 확정일자를 받은 경우 → 확정일자 기준 순위 확인 필요\n2. 매각대금에서 배당받을 수 있는 범위는 소액임차인 최우선변제금 범위 내\n3. 나머지는 낙찰자가 인수해야 할 수 있음\n\n정확한 분석을 위해 사건번호를 1:1 상담으로 보내주시면 상세 검토 도와드리겠습니다.", authorBadge: "마스터", isAI: true, createdAt: "2026-06-06" },
      { id: "q1c2", author: "강현우", authorBadge: "마스터", content: "AI 비서 답변에 보충하자면, 소액임차인 최우선변제금은 지역별로 상이합니다. 수도권은 보통 5,500만원 이하로 알고 계시면 됩니다.", createdAt: "2026-06-06" },
    ],
    tags: ["임차인", "보증금", "배당"],
  },
  {
    id: "q2",
    title: "근저당권 말소 기준이 헷갈립니다",
    content: "A라는 물건에 1번 근저당(채권최고액 2억), 2번 근저당(채권최고액 1억)이 설정되어 있어요. 경매 신청은 2번 근저당권자가 했습니다. 낙찰되면 1번 근저당은 어떻게 되나요? 말소되는 건가요?",
    category: "물건 Q&A",
    author: "권리분석초보",
    createdAt: "2026-06-04",
    views: 195,
    likes: 8,
    commentCount: 3,
    comments: [
      { id: "q2c1", author: "AI 경매비서", content: "좋은 질문입니다. 2번 근저당권자가 경매를 신청한 경우:\n\n- 1번 근저당: 후순위인 2번의 신청으로 경매가 진행되더라도 선순위인 1번 근저당은 말소되지 않습니다. 낙찰자가 인수하게 됩니다.\n- 2번 근저당: 경매 신청한 권리이므로 말소됩니다.\n\n즉, 낙찰자는 1번 근저당 2억을 인수한 상태로 소유권을 취득하게 됩니다. 입찰가 산정 시 반드시 고려해야 할 부분입니다.", authorBadge: "마스터", isAI: true, createdAt: "2026-06-04" },
    ],
    tags: ["근저당", "말소기준권리", "권리분석"],
  },
  {
    id: "q3",
    title: "경매로 취득한 집, 취득세는 어떻게 계산하나요?",
    content: "경매로 아파트를 낙찰받았는데 취득세가 일반 매매보다 더 나오나요? 낙찰가 4억 5천에 낙찰받았고, 이게 제 첫 주택인데 취득세 얼마나 나올지 계산 부탁드립니다.",
    category: "물건 Q&A",
    author: "첫낙찰성공",
    authorBadge: "정수강생",
    createdAt: "2026-06-02",
    views: 310,
    likes: 15,
    commentCount: 5,
    comments: [
      { id: "q3c1", author: "AI 경매비서", content: "경매 취득세는 일반 매매와 동일한 기준으로 계산됩니다.\n\n낙찰가 4억 5천 기준:\n- 1주택자: 1~3% (구간별 차등)\n- 4억 5천 기준 약 1.3% → 약 585만원 예상\n- 취득세 외 농어촌특별세, 지방교육세 등 부가세 포함 시 약 1.5~1.8% 수준\n\n정확한 계산은 관할 시군구 세무과에서 확인하시는 것이 가장 좋습니다.", authorBadge: "마스터", isAI: true, createdAt: "2026-06-02" },
    ],
    tags: ["취득세", "세금", "낙찰"],
  },
  {
    id: "q4",
    title: "지분 경매는 위험한가요?",
    content: "관심 있는 물건이 단독 소유가 아니라 1/2 지분만 경매에 나왔어요. 이런 지분 경매는 어떤 리스크가 있나요? 다른 지분권자와의 관계가 걱정됩니다.",
    category: "물건 Q&A",
    author: "초보투자자",
    createdAt: "2026-05-30",
    views: 450,
    likes: 22,
    commentCount: 6,
    comments: [
      { id: "q4c1", author: "AI 경매비서", content: "지분 경매의 주요 리스크:\n\n1. 다른 지분권자와 공유관계가 성립되어 실제 사용/수익이 어려울 수 있음\n2. 공유물분할소송이 필요할 수 있고, 이는 추가 비용과 시간 소요\n3. 다른 지분권자가 우선매수권을 행사할 수 있음\n4. 금융기관 대출이 일반 경매보다 까다로움\n\n지분 경매는 리스크 대비 낙찰가가 충분히 낮은 경우에만 접근하시는 것이 좋습니다.", authorBadge: "마스터", isAI: true, createdAt: "2026-05-30" },
    ],
    tags: ["지분경매", "공유물분할", "리스크"],
  },

  // ── 낙찰/임장 후기 ──
  {
    id: "r1",
    title: "드디어 첫 낙찰! 수원 권선구 아파트 3억 2천에 낙찰받았어요",
    content: "6개월간 강스터디에서 공부하고 드디어 첫 낙찰에 성공했습니다! 수원 권선구 소재 84㎡ 아파트를 3억 2천에 낙찰받았어요. 시세 4억 5천 정도 하는 물건이라 수익률 꽤 좋을 것 같습니다.\n\n입찰 전에 강현우 강사님의 1:1 상담을 통해 권리분석을 꼼꼼히 했고, 입찰계산기로 적정 입찰가를 산정해서 자신 있게 입찰했습니다. 입찰 당일은 정말 떨렸는데, 결과 발표 때 제 번호가 불렸을 때의 그 짜릿함은 평생 잊지 못할 것 같아요.\n\n현재 명도 절차 진행 중이고, 인테리어 조금만 하면 바로 입주하거나 임대 줄 예정입니다. 정말 강스터디 아니었으면 엄두도 못 냈을 텐데 감사합니다!",
    category: "낙찰/임장 후기",
    author: "첫낙찰기쁨",
    authorBadge: "정수강생",
    createdAt: "2026-06-08",
    views: 1580,
    likes: 142,
    commentCount: 28,
    isBest: true,
    thumbnail: "https://img.echotwin.kr/kangstudy/3e9240eeab8557cd.jpg",
    comments: [
      { id: "r1c1", author: "경매뉴비", authorBadge: "정수강생", content: "와 진짜 축하드려요!! 저도 얼른 첫 낙찰 하고 싶네요. 후기 보니까 더 열심히 해야겠다는 동기부여 됩니다.", createdAt: "2026-06-08" },
      { id: "r1c2", author: "강현우", authorBadge: "마스터", content: "축하합니다! 상담 때 보여주신 열정이 결실을 맺었네요. 앞으로도 좋은 투자 이어가시길 바랍니다.", createdAt: "2026-06-08" },
      { id: "r1c3", author: "낙찰왕", authorBadge: "마스터", content: "수원 권선구 좋은 동네죠. 3.2억이면 진짜 잘 잡으셨네요. 축하드립니다!", createdAt: "2026-06-08" },
    ],
  },
  {
    id: "r2",
    title: "서울 관악구 빌라 임장 후기 - 수익률 18% 예상",
    content: "지난주에 관악구 봉천동 쪽 빌라 물건 임장 다녀왔습니다. 경매 예정가 2억 8천, 시세 3억 8천 정도 되는 물건이에요.\n\n임장 체크 포인트:\n1. 역세권 - 2호선 서울대입구역 도보 8분\n2. 주변 임대료 - 비슷한 평수 월세 80-100만원 수준\n3. 건물 상태 - 2015년 준공으로 비교적 양호\n4. 주변 개발 호재 - 관악구 뉴타운 예정지 인접\n\n권리분석 결과 특이한 하자 없었고, 예상 수익률 약 18% 나와서 입찰 진행하려고 합니다. 다만 임차인이 2가구 있어서 명도 계획 잘 세워야 할 것 같아요.",
    category: "낙찰/임장 후기",
    author: "임장대장",
    authorBadge: "마스터",
    createdAt: "2026-06-05",
    views: 980,
    likes: 95,
    commentCount: 16,
    isBest: true,
    thumbnail: "https://img.echotwin.kr/kangstudy/efd1a838a6e75962.jpg",
    comments: [
      { id: "r2c1", author: "초보탈출", content: "임장 후기 정말 유익합니다! 저도 다음에 꼭 임장 가보고 싶네요.", createdAt: "2026-06-05" },
      { id: "r2c2", author: "공부하는직장인", authorBadge: "정수강생", content: "18% 수익률이면 정말 좋은 물건이네요. 명도 계획도 잘 세우세요!", createdAt: "2026-06-06" },
    ],
  },
  {
    id: "r3",
    title: "경매 2년차, 누적 수익 1억 돌파했습니다!",
    content: "2024년부터 강스터디에서 경매를 배우기 시작해서 지금까지 총 4건 낙찰, 누적 수익 1억을 돌파했습니다!\n\n낙찰 이력:\n1. 2024.03 - 안양 아파트 (수익 +2,500만원)\n2. 2024.09 - 군포 빌라 (수익 +1,800만원)\n3. 2025.04 - 의왕 오피스텔 (수익 +3,200만원)\n4. 2026.01 - 수원 아파트 (수익 +2,800만원)\n\n가장 중요한 건 '안전 마진'을 충분히 두는 것과, 명도 절차를 처음부터 계획하는 거였어요. 강현우 강사님의 '절대 지지 않는 경매' 강의가 정말 큰 도움이 됐습니다.",
    category: "낙찰/임장 후기",
    author: "경매프로",
    authorBadge: "마스터",
    createdAt: "2026-06-01",
    views: 2340,
    likes: 210,
    commentCount: 35,
    isBest: true,
    thumbnail: "https://img.echotwin.kr/kangstudy/a704982f380815dd.jpg",
    comments: [
      { id: "r3c1", author: "첫입찰준비", authorBadge: "정수강생", content: "진짜 대단하세요! 1억 수익이면 경매 마스터 인정입니다. 존경합니다!", createdAt: "2026-06-01" },
      { id: "r3c2", author: "직장인투자자", content: "안전 마진의 중요성을 다시 한번 깨닫게 되네요. 팁 감사합니다.", createdAt: "2026-06-02" },
    ],
  },
  {
    id: "r4",
    title: "첫 임장 다녀왔어요 - 인천 부평구 빌라",
    content: "강의에서 배운 대로 첫 임장 다녀왔습니다! 인천 부평구 쪽 빌라 물건이었는데, 실제로 가보니까 인터넷 사진이랑 꽤 다르더라고요.\n\n• 골목이 생각보다 좁고 주차가 어려움\n• 바로 옆 건물이 증축 중이라 소음 이슈\n• 근처에 대형 마트 없고 편의점만 있음\n\n역시 직접 발로 뛰어야 진짜 정보를 얻을 수 있다는 걸 실감했어요. 물건 자체는 나쁘지 않았지만 접근성 이슈로 입찰은 보류하려고 합니다. 초보자분들도 꼭 직접 임장 가보세요!",
    category: "낙찰/임장 후기",
    author: "초보탈출",
    createdAt: "2026-05-28",
    views: 760,
    likes: 55,
    commentCount: 11,
    isBest: true,
    thumbnail: "https://img.echotwin.kr/kangstudy/c7df4699a00f5a7f.jpg",
    comments: [
      { id: "r4c1", author: "임장대장", authorBadge: "마스터", content: "좋은 후기네요! 사진만 보고 판단하면 큰일 나죠. 보류 결정 잘하셨어요.", createdAt: "2026-05-28" },
    ],
  },
  {
    id: "r5",
    title: "경매로 내 집 마련 성공! 인생 첫 집이에요",
    content: "전세 살다가 드디어 경매로 내 집 마련했습니다! 화성 동탄 2신도시 74㎡ 아파트를 5억 2천에 낙찰받았어요.\n\n실거주 목적이라 수익률보다는 '살기 좋은 집'에 초점을 맞췄어요. 초등학교 도보 5분, 공원이 바로 앞이라 아이 키우기 정말 좋은 환경이에요. 경매라는 게 꼭 투자 목적만 있는 게 아니라, 이렇게 실수요자에게도 정말 좋은 방법이라는 걸 알리고 싶어요.\n\n명도는 순조롭게 진행되었고, 현재 리모델링 공사 중입니다. 다음 달이면 입주해요! 강스터디 커뮤니티 덕분에 용기 낼 수 있었습니다.",
    category: "낙찰/임장 후기",
    author: "행복한아빠",
    authorBadge: "정수강생",
    createdAt: "2026-05-25",
    views: 1850,
    likes: 178,
    commentCount: 42,
    isBest: true,
    thumbnail: "https://img.echotwin.kr/kangstudy/e9eea23a972e6b02.jpg",
    comments: [],
  },
];

export const categoryKeys: Record<string, string> = {
  notice: "공지/이벤트",
  free: "자유수다",
  qna: "물건 Q&A",
  review: "낙찰/임장 후기",
};

export const bestReviews = posts.filter((p) => p.isBest);